import { addDays, toLocalDate } from '@painpal/core';

export type FitnessRange = '6w' | '3m' | '1y' | 'all';
export const FITNESS_RANGES: readonly FitnessRange[] = ['6w', '3m', '1y', 'all'];
export const RANGE_LABEL: Record<FitnessRange, string> = { '6w': 'LAST 6 WEEKS', '3m': 'LAST 3 MONTHS', '1y': 'LAST YEAR', all: 'ALL TIME' };

const RANGE_DAYS: Record<Exclude<FitnessRange, 'all'>, number> = { '6w': 42, '3m': 90, '1y': 365 };

export function browserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function todayLocal(now: Date = new Date()): string {
  return toLocalDate(now, browserTimeZone());
}

export function rangeStart(range: FitnessRange, today: string): string | null {
  return range === 'all' ? null : addDays(today, -RANGE_DAYS[range]);
}
